import { __awaiter } from "tslib";
import { createSlice } from '../context';
import { CommandsReady } from './commands';
export const prosePluginsCtx = createSlice([], 'prosePlugins');
export const prosePluginFactory = (plugin) => () => (ctx) => __awaiter(void 0, void 0, void 0, function* () {
    yield ctx.wait(CommandsReady);
    const plugins = typeof plugin === 'function' ? [plugin(ctx)] : [plugin];
    ctx.update(prosePluginsCtx, (prev) => prev.concat(plugins.flat()));
});
//# sourceMappingURL=prose-plugin-factory.js.map